// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../../fetch.pb.js";
export var ListRecipientsRequest_AppointmentQualifier;
(function (ListRecipientsRequest_AppointmentQualifier) {
    ListRecipientsRequest_AppointmentQualifier["UNSPECIFIED"] = "UNSPECIFIED";
    ListRecipientsRequest_AppointmentQualifier["LAST_SEEN"] = "LAST_SEEN";
    ListRecipientsRequest_AppointmentQualifier["NEXT_APPOINTMENT"] = "NEXT_APPOINTMENT";
    ListRecipientsRequest_AppointmentQualifier["NO_APPOINTMENT"] = "NO_APPOINTMENT";
})(ListRecipientsRequest_AppointmentQualifier || (ListRecipientsRequest_AppointmentQualifier = {}));
export var ListRecipientsRequest_AppointmentQualifier_index;
(function (ListRecipientsRequest_AppointmentQualifier_index) {
    ListRecipientsRequest_AppointmentQualifier_index[ListRecipientsRequest_AppointmentQualifier_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ListRecipientsRequest_AppointmentQualifier_index[ListRecipientsRequest_AppointmentQualifier_index["LAST_SEEN"] = 1] = "LAST_SEEN";
    ListRecipientsRequest_AppointmentQualifier_index[ListRecipientsRequest_AppointmentQualifier_index["NEXT_APPOINTMENT"] = 2] = "NEXT_APPOINTMENT";
    ListRecipientsRequest_AppointmentQualifier_index[ListRecipientsRequest_AppointmentQualifier_index["NO_APPOINTMENT"] = 3] = "NO_APPOINTMENT";
})(ListRecipientsRequest_AppointmentQualifier_index || (ListRecipientsRequest_AppointmentQualifier_index = {}));
export var RecipientFilterOption_FilterType;
(function (RecipientFilterOption_FilterType) {
    RecipientFilterOption_FilterType["UNSPECIFIED"] = "UNSPECIFIED";
    RecipientFilterOption_FilterType["PRIMARY_INSURANCE"] = "PRIMARY_INSURANCE";
    RecipientFilterOption_FilterType["APPOINTMENT_TYPE"] = "APPOINTMENT_TYPE";
    RecipientFilterOption_FilterType["APPOINTMENT_STATUS"] = "APPOINTMENT_STATUS";
    RecipientFilterOption_FilterType["RECIPIENT_STATUS"] = "RECIPIENT_STATUS";
    RecipientFilterOption_FilterType["APPOINTMENT_PRACTITIONER"] = "APPOINTMENT_PRACTITIONER";
    RecipientFilterOption_FilterType["RECALL_TYPE"] = "RECALL_TYPE";
    RecipientFilterOption_FilterType["SOURCE_TENANT"] = "SOURCE_TENANT";
})(RecipientFilterOption_FilterType || (RecipientFilterOption_FilterType = {}));
export var RecipientFilterOption_FilterType_index;
(function (RecipientFilterOption_FilterType_index) {
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["PRIMARY_INSURANCE"] = 2] = "PRIMARY_INSURANCE";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["APPOINTMENT_TYPE"] = 3] = "APPOINTMENT_TYPE";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["APPOINTMENT_STATUS"] = 4] = "APPOINTMENT_STATUS";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["RECIPIENT_STATUS"] = 5] = "RECIPIENT_STATUS";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["APPOINTMENT_PRACTITIONER"] = 6] = "APPOINTMENT_PRACTITIONER";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["RECALL_TYPE"] = 7] = "RECALL_TYPE";
    RecipientFilterOption_FilterType_index[RecipientFilterOption_FilterType_index["SOURCE_TENANT"] = 8] = "SOURCE_TENANT";
})(RecipientFilterOption_FilterType_index || (RecipientFilterOption_FilterType_index = {}));
export var SmsNumberEntry_InvalidReason;
(function (SmsNumberEntry_InvalidReason) {
    SmsNumberEntry_InvalidReason["UNSPECIFIED"] = "UNSPECIFIED";
    SmsNumberEntry_InvalidReason["INVALID_PHONE_NUMBER"] = "INVALID_PHONE_NUMBER";
    SmsNumberEntry_InvalidReason["INVALID_SMS_NUMBER"] = "INVALID_SMS_NUMBER";
    SmsNumberEntry_InvalidReason["OPTED_OUT"] = "OPTED_OUT";
})(SmsNumberEntry_InvalidReason || (SmsNumberEntry_InvalidReason = {}));
export var SmsNumberEntry_InvalidReason_index;
(function (SmsNumberEntry_InvalidReason_index) {
    SmsNumberEntry_InvalidReason_index[SmsNumberEntry_InvalidReason_index["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SmsNumberEntry_InvalidReason_index[SmsNumberEntry_InvalidReason_index["INVALID_PHONE_NUMBER"] = 1] = "INVALID_PHONE_NUMBER";
    SmsNumberEntry_InvalidReason_index[SmsNumberEntry_InvalidReason_index["INVALID_SMS_NUMBER"] = 2] = "INVALID_SMS_NUMBER";
    SmsNumberEntry_InvalidReason_index[SmsNumberEntry_InvalidReason_index["OPTED_OUT"] = 3] = "OPTED_OUT";
})(SmsNumberEntry_InvalidReason_index || (SmsNumberEntry_InvalidReason_index = {}));
export const MetlBulkService = {
    /**
     * ListRecipients returns a filtered and sorted list of Recipients for Bulk Messaging or Email Marketing.
     * Results are sorted by sort_name.
     */
    ListRecipients(fn, req) {
        return fn(`/messaging/etl/bulk/v1/recipients?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * CountRecipients returns a count of the rows in the result set from ListRecipients.
     */
    CountRecipients(fn, req) {
        return fn(`/messaging/etl/bulk/v1/recipients/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * RecipientFilterOptions returns valid filter options for a Location.
     */
    RecipientFilterOptions(fn, req) {
        return fn(`/messaging/etl/bulk/v1/recipients/filter-options?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ValidateSmsNumbers checks whether phone numbers are textable or opted out of marketing messages
     * textable = no sms_number row with valid=false
     */
    ValidateSmsNumbers(fn, req) {
        return fn(`/messaging/etl/bulk/v1/smsnumbers/validate?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    PersonSearch(fn, req) {
        return fn(`/messaging/etl/bulk/v1/person/search?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
